<button mat-button [matMenuTriggerFor]="menu">
    <mat-icon>menu</mat-icon>
</button>
<mat-menu #menu="matMenu">
    @for(item of menuItems(); track item) {
    <button mat-menu-item (click)="menuItemSelector(item)">{{item}}</button>
    }
</mat-menu>
